import AdvertiserNote from './AdvertiserNote';

export default AdvertiserNote;
